import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { PercentPipe } from '@angular/common';
import { slaBand } from '../sla-rules';

/**
 * Renders a % Met SLA value as a color-banded chip.
 * Band colors follow the Exec Dashboard key: >=90% good, >=80% warning, <80% miss.
 * Blank values (no tickets) render as an em dash, matching the sheet's blank cells.
 */
@Component({
  selector: 'app-pct-chip',
  imports: [PercentPipe],
  template: `
    @if (pct() !== null) {
      <span class="pct-chip" [class]="'band-' + band()">
        <span class="dot" aria-hidden="true"></span>{{ pct() | percent: '1.1-1' }}
      </span>
    } @else {
      <span class="pct-empty">—</span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PctChip {
  readonly pct = input.required<number | null>();
  protected readonly band = computed(() => slaBand(this.pct()));
}
